import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { Box } from '@mui/material';
import PasswordResetForm from '../../components/AuthForms/PasswordResetForm';

/**
 * PasswordReset Page
 * Simple container page for password reset functionality
 * Extracts oobCode from URL and renders the PasswordResetForm component
 */
const PasswordReset: React.FC = () => {
  const [searchParams] = useSearchParams();

  // Extract oobCode from URL parameters
  const oobCode = searchParams.get('oobCode') || '';

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: 'calc(100vh - 120px)',
        p: 2.5,
      }}
    >
      <PasswordResetForm oobCode={oobCode} />
    </Box>
  );
};

export default PasswordReset;
